if (!Object.values) {
    Object.values = function(O) {
        return [].reduce.call(Object.keys(O), (e, k) => [].concat.call(e, typeof k === 'string' && {}.propertyIsEnumerable.call(O, k) ? [O[k]] : []), []);
    }
}
